import { gql } from '@apollo/client';

export const ASSET_HIERARCHY_IMPORT_STATUS_CHANGED = gql`
  subscription assetHierarchyImportStatusChanged {
    assetHierarchyImportStatusChanged {
      providerCode
      statusCode
      statusData
      progress
      message
      actionMoment
    }
  }
`;
